import { SVGProps, Ref, forwardRef } from 'react';

export const LoaderOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 1.867A6.133 6.133 0 1 0 14.133 8h1.2A7.334 7.334 0 1 1 8 .667z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LoaderOutlinedSize16Glyph.displayName = 'LoaderOutlinedSize16Glyph';
